import { Button } from '@shared/components/shadcn';
import { APPLE_PAY_BUTTON_CLASS_NAME } from '../../../../../applePayButtonClassName';
import { CheckoutPayButtonContent, type CheckoutPayButtonContentProps } from './CheckoutPayButtonContent';

type CheckoutPayButtonProps = CheckoutPayButtonContentProps & {
  isDisabled: boolean;
  onClick: () => void;
  trackingProps?: Record<string, string>;
  showActionsContainer?: boolean;
};

function CheckoutPayButton({
  isSubmitting,
  isApplePay,
  ctaLabel,
  applePayPayWithLabel,
  applePayPayLabel,
  isDisabled,
  onClick,
  trackingProps,
  showActionsContainer = false,
}: CheckoutPayButtonProps) {
  const applePayClassName = isApplePay ? ` ${APPLE_PAY_BUTTON_CLASS_NAME}` : '';
  const buttonClassName = showActionsContainer ? `w-full${applePayClassName}` : `w-full mt-auto mb-2${applePayClassName}`;

  const button = (
    <Button type="button" className={buttonClassName} onClick={onClick} disabled={isDisabled} data-testid="checkout-cta-button" {...trackingProps}>
      <CheckoutPayButtonContent
        isSubmitting={isSubmitting}
        isApplePay={isApplePay}
        ctaLabel={ctaLabel}
        applePayPayWithLabel={applePayPayWithLabel}
        applePayPayLabel={applePayPayLabel}
      />
    </Button>
  );

  if (!showActionsContainer) {
    return button;
  }

  return (
    <div className="mt-auto mb-2" data-track-container="Actions">
      {button}
    </div>
  );
}

export { CheckoutPayButton, type CheckoutPayButtonProps };
